import * as apiTo from '@/modular-api'

function findCurrentFinancialPeriod(periods) {
  const period = periods.find(p => p.is_current)
  return period.id
}

function get4FinancialPeriods(periods) {
  const threePeriods = []
  const currIndex = periods.findIndex(p => p.is_current)

  threePeriods.push(periods[currIndex])
  if (periods[currIndex + 1]) threePeriods.push(periods[currIndex + 1])
  if (periods[currIndex + 2]) threePeriods.push(periods[currIndex + 2])
  if (periods[currIndex + 3]) threePeriods.push(periods[currIndex + 3])

  return threePeriods
}

export default {
  namespaced: true,

  state: () => ({
    financialPeriods: [],
    financialPeriodId: null,
    loadingFinancialPeriods: false,
    departments: []
  }),

  getters: {
    systemDepartment: state => state.departments.find(dep => dep.system)
  },

  mutations: {
    setLoadingFinancialPeriods: (state, payload) => (state.loadingFinancialPeriods = payload),
    setFinancialPeriodId: (state, payload) => (state.financialPeriodId = payload),
    setFinancialPeriods: (state, payload) => (state.financialPeriods = payload),
    setDepartments: (state, payload) => (state.departments = payload)
  },

  actions: {
    getAndSetFinancialPeriods({ commit }) {
      commit('setLoadingFinancialPeriods', true)
      return apiTo
        .GET_FINANCIAL_PERIODS()
        .then(({ data }) => {
          commit('setFinancialPeriods', get4FinancialPeriods(data.result))
          commit('setFinancialPeriodId', findCurrentFinancialPeriod(data.result))
        })
        .finally(() => commit('setLoadingFinancialPeriods', false))
    },

    getAndSetDepartments({ commit }) {
      return apiTo.GET_DEPARTMENTS().then(({ data }) => commit('setDepartments', data.result))
    }
  }
}
